export default __webpack_public_path__ + "static/os-icons-img-e9a19783bf0c506cca9142f8b950a6ee.png";